const classNames = classnames => {
  if (!Array.isArray(classnames)) {
    classnames = [classnames]
  }
  return classnames.filter(classname => typeof classname === "string").join(" ")
}

export default classNames
